<template>
  <div style="min-width: 1500px; overflow-y: auto;">
    <div id="app">
      <router-view></router-view>
    </div>
    <FooterVue v-if="$route.name !== 'login'"></FooterVue>
  </div>
</template>

<script>
import FooterVue from "./components/footer.vue";
import { getToken } from "@/utils/auth";
import store from "@/store";

export default {
  name: "App",
  components: {
    FooterVue,
  },
  watch: {
    $route(to, from) {
      // 使用 nextTick 确保 DOM 更新后滚动
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
  },
  mounted() {
    if (getToken()) store.dispatch("setToken", getToken());
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 1300px;
  min-height: calc(100vh - 240px);
  margin: 0 auto;
  z-index: 10;
  position: relative;
}
</style>
